import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Media from "css/Media";
import moment from 'moment';

import api from 'api';

import EventCard from '../views/Events/EventCard';
import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Calender from 'icons/CalenderIcon';

function EventCalendar({ data }) {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        api.eventFetcher.getAll().then((res) => filterOldEvents(res.data));
    }, []);

    const filterOldEvents = (events) => {
        let sortByUpcoming = [];
        let prev = [];

        const checkDate = (a, b) => {
            if (a.acf.from_date > b.acf.from_date) {
                return 1;
            } else if (a.acf.from_date < b.acf.from_date) {
                return -1;
            } else {
                return 0;
            }
        }

        events.map(event => {
            //event comes after todays date
            if (!moment(event.acf.from_date).isBefore(moment())) {
                sortByUpcoming.push(event)
            }
            //event starts before todays date but ends after it
            else if (event.acf.end_date) {
                if (moment(event.acf.from_date).isBefore(moment()) && moment(event.acf.end_date).isAfter(moment())) {
                    sortByUpcoming.push(event)
                }
            } else prev.push(event)
            return null;
        })
        let sorted = sortByUpcoming.sort((a, b) => checkDate(a, b));
        setEvents(sorted);
    }

    let row = 1;

    return (
        <Wrapper>
            <Container grid>
                <DescriptionGridElement
                    colStart={{ default: 1, s: 5 }}
                    colEnd={{ default: 8, s: 20 }}
                    rowStart={1}
                    justify="center"
                >
                    <h2>{data.title}</h2>
                    <Calender />
                </DescriptionGridElement>
                {events && events.length > 0 ? events.map((event, idx) => {
                    idx % 2 == 0 ? row++ : row;

                    return (
                        <StyledGridElement
                            colStart={(idx % 2 == 0) ? { default: 1, s: 3 } : { default: 1, s: 13 }}
                            colEnd={(idx % 2 == 0) ? { default: 8, s: 12 } : { default: 8, s: 22 }}
                            rowStart={{ default: idx + 2, s: row }}
                            key={event.id}
                        >
                            <EventCard event={event} />
                        </StyledGridElement>
                    )
                })
                    : null}
            </Container>
        </Wrapper>
    );
}

export default EventCalendar;

const Wrapper = styled.section`
    scroll-behavior: smooth;
    width: 100%;
`

const DescriptionGridElement = styled(GridElement)`
    display: flex;
    align-items: center;
    margin-bottom: ${props => props.theme.spacing.elementS};

    ${Media.greaterThan('s')`
        margin-bottom: ${props => props.theme.spacing.blockM};
    ` }

    h2 {
        margin-right: ${props => props.theme.spacing.contentM};

        ${Media.greaterThan('s')`
            margin-right: ${props => props.theme.spacing.contentXL};
        ` } 
    }

    svg {
        fill: ${props => props.theme.colors.text};
        height: 26px;
        width: 26px;

        ${Media.greaterThan('s')`
            height: 45px;
            width: 45px;
        ` } 
    }
`

const StyledGridElement = styled(GridElement)`
    margin-bottom: ${props => props.theme.spacing.elementS};

    &:last-of-type {
        margin-bottom: ${props => props.theme.spacing.blockM};
    }

    ${Media.greaterThan('s')`
        margin-bottom: ${props => props.theme.spacing.blockM};
    ` } 
`